<script>
import UsersTable from "@/components/elements/UsersTable";
import { mapGetters } from "vuex";

export default {
	components: {
		UsersTable
	},
	computed: {
		...mapGetters("users", ["selectedUser"]),
		user() {
			return this.selectedUser;
		}
	}
};
</script>

<template>
	<v-row>
		<v-col md="12" cols="12">
			<users-table/>
		</v-col>
	</v-row>
</template>



// WEBPACK FOOTER //
// src/components/views/UsersSection.vue